// extracted by mini-css-extract-plugin
export default {"alert":"alert_alert__eXlWM","error":"alert_error__pWHSd","success":"alert_success__hzqsR","info":"alert_info__AeUes"};